// extracted by mini-css-extract-plugin
export default {"disabled":"TLNlUeco9KgwyeeZPZQB"};